import {
  API_GET_SOURCE_GEO_TEMPLATE,
  API_GET_SOURCE_IMPORT_HISTORY,
  API_IMPORT_SOURCE_GEO_FILE,
} from "@/config/api.config";
import apiCall from "@/utils/api";
import downloadFile from "@/utils/file";

export const FETCH_SOURCE_IMPORT_HISTORY = "FETCH_SOURCE_IMPORT_HISTORY";
export const SET_SOURCE_IMPORT_HISTORY = "SET_SOURCE_IMPORT_HISTORY";
export const FETCH_SOURCE_GEO_TEMPLATE = "FETCH_SOURCE_GEO_TEMPLATE";
export const IMPORT_SOURCE_GEO_FILE = "IMPORT_SOURCE_GEO_FILE";

export default {
  [FETCH_SOURCE_IMPORT_HISTORY]({ commit }, { params } = {}) {
    commit("SET_LOADING", true);
    commit("SET_ERROR", null);

    return apiCall({
      method: API_GET_SOURCE_IMPORT_HISTORY,
      params,
    })
      .then(({ status, data }) => {
        if (status === 200 && !data.error) {
          commit(SET_SOURCE_IMPORT_HISTORY, data);
          return data;
        }
        throw data;
      })
      .catch((error) => {
        commit("SET_ERROR", error.details || error.message);
        throw error;
      })
      .finally(() => {
        commit("SET_LOADING", false);
      });
  },
  [FETCH_SOURCE_GEO_TEMPLATE]() {
    return new Promise((resolve, reject) => {
      return downloadFile({
        method: API_GET_SOURCE_GEO_TEMPLATE,
      }).then((response) => {
        let { status, data } = response;
        if (status === 200 && !data.error) {
          resolve(data);
        } else {
          reject(data);
        }
      });
    });
  },
  [IMPORT_SOURCE_GEO_FILE](context, { formData }) {
    return new Promise((resolve, reject) => {
      return apiCall({
        method: API_IMPORT_SOURCE_GEO_FILE,
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
      }).then((response) => {
        let { status, data } = response;
        if (status === 200 && !data.error) {
          resolve(data.data);
        } else {
          reject(data.details);
        }
      });
    });
  },
};
